import useSWR from 'swr';
import useOwnerOrgId from '@/lib/hooks/useOwnerOrgId';
import { useCurrentUser } from '@/lib/hooks/userData';
import type User from '@/types/api/User';
import { fetcher } from '@/utils/services';

const useBulkActionStatus = () => {
  const ownerOrgId = useOwnerOrgId();
  const { user }: { user: User | undefined } = useCurrentUser();
  const { userId } = user || {};
  const key =
    ownerOrgId && userId
      ? `admin/bulk-actions?owner_org_id=${ownerOrgId}&user_id=${userId}`
      : null;
  return useSWR(key, fetcher, { revalidateOnFocus: false });
};

export default useBulkActionStatus;
